import React from 'react';
import { useParams } from 'react-router-dom';
import { CampaignConfigBuilder } from '../components/CampaignConfigBuilder';

export const CampaignConfigBuilderPage: React.FC = () => {
  const { configId } = useParams<{ configId?: string }>();

  return <CampaignConfigBuilder configId={configId} />;
};
